<template>
    <div>
        <v-container fluid pa-0>
            <v-container fluid grid-list-xl class="toolbar-container">
                  <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                      <v-toolbar color="grey lighten-3" elevation="1">
                          <bc-btn-back></bc-btn-back>
                          <v-toolbar-title class="ml-0">{{$t($route.meta.title)}}</v-toolbar-title>
                          <v-spacer></v-spacer>
                          <bc-modal-print
                              ref="print"
                              @close-method="file_name = null, $refs.print.close()"
                              :file-name="file_name"
                              :no-button="true"
                          ></bc-modal-print>
                          <bc-btn-refresh v-if="manufacturer.company_id && manufacturer.company_id > 0"
                                @invoke-method="dbGetManufacturer(true)"
                            ></bc-btn-refresh>
                          <v-menu left content-class="no-stripe" v-if="manufacturer.company_id && manufacturer.company_id > 0">
                              <template slot="activator">
                                  <v-btn icon>
                                      <v-icon>more_vert</v-icon>
                                  </v-btn>
                              </template>
                              <v-list>
                                  <v-list-tile @click="printPDF()">
                                      <v-list-tile-title>
                                          Print
                                      </v-list-tile-title>
                                  </v-list-tile>
                                  <template v-if="hasPerm('manufacturers.update')">
                                      <v-divider class="ml-3 my-0"></v-divider>

                                      <div v-for="item in manufacturer_status_options" :key="item.option_id">
                                      <v-list-tile @click="changeStatus(item)" v-if="item.option_id != manufacturer.status_id">
                                          <v-list-tile-title>
                                              {{ $t(`lang.mark_as_${item.slug}`) ? $t(`lang.mark_as_${item.slug}`) : `Mark as ${item.option}` }}
                                          </v-list-tile-title>
                                      </v-list-tile>
                                      </div>

                                  </template>
                                  <template v-if="hasPerm('manufacturers.delete')">
                                      <v-divider class="ml-3 my-0"></v-divider>
                                      <v-list-tile @click="$refs.delete_manufacturer.openDialog()">
                                          <v-list-tile-title>
                                              Delete
                                          </v-list-tile-title>
                                      </v-list-tile>
                                  </template>
                              </v-list>
                          </v-menu>
                          <bc-tooltip>
                              <template slot="activator">
                                  <v-btn
                                      icon
                                      @mouseup.left="$router.push({ name: 'manufacturers' })"
                                  >
                                      <v-icon>close</v-icon>
                                  </v-btn>
                              </template>
                              {{ $t('lang.back_to_list') }}
                          </bc-tooltip>
                      </v-toolbar>
                  </v-layout>
              </v-container>

            <v-card-text>
                <v-card elevation="10">
                    <v-card-text>
                        <div v-if="manufacturer.status" class="ribbon ribbon-top-right" :class="`ribbon-${manufacturer.status_class}`"><span class="ribbon-span">{{ manufacturer.status }}</span></div>
                        <v-form ref="formManufacturer">
							<v-flex xs12>
								<v-text-field
									v-focus="manufacturer_dialog"
									v-model="manufacturer.company_id"
									:label="$t('lang.company_id')"
									:counter="showCounter(manufacturer.company_id, 'manufacturers.company_id')"
									:rules="ifValid('manufacturers.company_id')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="manufacturer.parent_id"
									:label="$t('lang.parent_id')"
									:counter="showCounter(manufacturer.parent_id, 'manufacturers.parent_id')"
									:rules="ifValid('manufacturers.parent_id')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="manufacturer.stripe_id"
									:label="$t('lang.stripe_id')"
									:counter="showCounter(manufacturer.stripe_id, 'manufacturers.stripe_id')"
									:rules="ifValid('manufacturers.stripe_id')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="manufacturer.zoho_customer_id"
									:label="$t('lang.zoho_customer_id')"
									:counter="showCounter(manufacturer.zoho_customer_id, 'manufacturers.zoho_customer_id')"
									:rules="ifValid('manufacturers.zoho_customer_id')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="manufacturer.organisation_type_id"
									:label="$t('lang.organisation_type_id')"
									:counter="showCounter(manufacturer.organisation_type_id, 'manufacturers.organisation_type_id')"
									:rules="ifValid('manufacturers.organisation_type_id')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="manufacturer.company"
									:label="`${$t('lang.company')} *`"
									:counter="showCounter(manufacturer.company, 'manufacturers.company')"
									:rules="ifValid('manufacturers.company')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="manufacturer.company_short"
									:label="$t('lang.company_short')"
									:counter="showCounter(manufacturer.company_short, 'manufacturers.company_short')"
									:rules="ifValid('manufacturers.company_short')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="manufacturer.website"
									:label="$t('lang.website')"
									:counter="showCounter(manufacturer.website, 'manufacturers.website')"
									:rules="ifValid('manufacturers.website')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="manufacturer.correspondence_method"
									:label="`${$t('lang.correspondence_method')} *`"
									:counter="showCounter(manufacturer.correspondence_method, 'manufacturers.correspondence_method')"
									:rules="ifValid('manufacturers.correspondence_method')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="manufacturer.currency_code"
									:label="`${$t('lang.currency_code')} *`"
									:counter="showCounter(manufacturer.currency_code, 'manufacturers.currency_code')"
									:rules="ifValid('manufacturers.currency_code')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="manufacturer.exchange_rate_id"
									:label="`${$t('lang.exchange_rate_id')} *`"
									:counter="showCounter(manufacturer.exchange_rate_id, 'manufacturers.exchange_rate_id')"
									:rules="ifValid('manufacturers.exchange_rate_id')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<bc-autocomplete
									v-model="manufacturer.payment_term_id"
									:label="$t('lang.payment_term')"
									:items="payment_terms"
									item-value="payment_term_id"
									item-text="payment_term_id"
									:rules="ifValid('manufacturers.payment_term_id')"
								></bc-autocomplete>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="manufacturer.turn_around_days"
									:label="$t('lang.turn_around_days')"
									:counter="showCounter(manufacturer.turn_around_days, 'manufacturers.turn_around_days')"
									:rules="ifValid('manufacturers.turn_around_days')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<bc-select
									v-model="manufacturer.has_nda"
									:label="`${$t('lang.has_nda')} *`"
									:items="[]"
									item-value="value"
									item-text="text"
									:rules="ifValid('manufacturers.has_nda')"
								></bc-select>
							</v-flex>
							<v-flex xs12>
								<bc-select
									v-model="manufacturer.has_contract"
									:label="`${$t('lang.has_contract')} *`"
									:items="[]"
									item-value="value"
									item-text="text"
									:rules="ifValid('manufacturers.has_contract')"
								></bc-select>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="manufacturer.ship_label_type"
									:label="`${$t('lang.ship_label_type')} *`"
									:counter="showCounter(manufacturer.ship_label_type, 'manufacturers.ship_label_type')"
									:rules="ifValid('manufacturers.ship_label_type')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-textarea
									v-model="manufacturer.notes"
									:label="$t('lang.notes')"
									auto-grow
									rows="1"
									:rules="ifValid('manufacturers.notes')"
								></v-textarea>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="manufacturer.logo_id"
									:label="$t('lang.logo_id')"
									:counter="showCounter(manufacturer.logo_id, 'manufacturers.logo_id')"
									:rules="ifValid('manufacturers.logo_id')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="manufacturer.packing_list_fields"
									:label="$t('lang.packing_list_fields')"
									:counter="showCounter(manufacturer.packing_list_fields, 'manufacturers.packing_list_fields')"
									:rules="ifValid('manufacturers.packing_list_fields')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="manufacturer.logo"
									:label="$t('lang.logo')"
									:counter="showCounter(manufacturer.logo, 'manufacturers.logo')"
									:rules="ifValid('manufacturers.logo')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<bc-select
									v-model="manufacturer.status"
									:label="`${$t('lang.status')} *`"
									:items="[]"
									item-value="value"
									item-text="text"
									:rules="ifValid('manufacturers.status')"
								></bc-select>
							</v-flex>


                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @mouseup.left="$router.push({ name: 'manufacturers' })" flat >{{$t('lang.cancel')}}</v-btn>
                        <v-btn color="success" @click="saveManufacturers">{{$t('lang.save')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-card-text>

            <delete-confirmation-dialog
                ref="delete_manufacturer"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_manufacturer')"
                :message="$t('lang.delete_manufacturer_confirm')"
                @onConfirm="deleteManufacturers()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_manufacturer_details"
                :heading="$t('lang.delete_package')"
                @onConfirm="confirmDeleteManufacturerDetails()"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],

            formData: {},
            manufacturer: {},
            file_name: "",
            dbGetManufacturer: _.debounce(this.getManufacturer, 1500, { maxWait: 1500, leading: true, trailing: false }),
            customers: null,
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchManufacturer", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.manufacturer) {
                        this.manufacturer = this.assignObj2(data.manufacturer, this.rules_manufacturers);

                        this.$store.dispatch("fetchSetting", {
                            url: "options?slug=manufacturer_status&sort_by=2",
                            method: "get",
                            stateProperty: "manufacturer_status_options",
                            dataProperty: "options",
                            commit: true,
                        });

                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "manufacturers", replace: true });
                    }
                });
        } else {
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchManufacturer", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.manufacturer) {
                        next((vm) => {
                            vm.manufacturer = vm.assignObj2(data.manufacturer, vm.rules_manufacturers);

                            store.dispatch("fetchSetting", {
                                url: "options?slug=manufacturer_status&sort_by=2",
                                method: "get",
                                stateProperty: "manufacturer_status_options",
                                dataProperty: "options",
                                commit: true,
                            });

                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "manufacturers", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.finishLoader();
            });
        }

        /*store.dispatch("fetchSetting", {
            url: "options?slug=manufacturer_status&sort_by=2",
            method: "get",
            stateProperty: "manufacturer_status_options",
            dataProperty: "options",
            commit: true,
        });*/
    },
    computed: {
        ...mapState({
            rules_manufacturers: (state) => state.manufacturers.rules_manufacturers,
            manufacturer_status_options: (state) => state.settings.manufacturer_status_options,
            manufacturers: (state) => state.manufacturers.manufacturers,
            selectedManufacturer: (state) => state.manufacturers.selectedManufacturer,
            payment_terms: (state) => state.payment_terms.payment_term_options,
        }),
    },
    methods: {
        ...mapActions(["fetchManufacturer", "saveManufacturer", "deleteManufacturer", "printManufacturer", "fetchPaymentTerms"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),

        getManufacturer(pg_refresh = false) {
            this.startLoader();

            this.fetchManufacturer({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.manufacturer) {
                    this.manufacturer = this.assignObj2(data.manufacturer, this.rules_manufacturers);
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        printPDF() {
            this.dev_mode ? this.$refs.print.openDialog() : this.toggleGlobalSnackbar(true);

            this.printManufacturer({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data != "undefined" && data.manufacturer) {
                    if (this.dev_mode) {
                        this.file_name = data.manufacturer.file_name;
                    } else {
                        this.$refs.print.printReport(data.manufacturer.file_name);
                    }

                    if (!this.dev_mode) this.toggleGlobalSnackbar(false);
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        saveManufacturers() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formManufacturer")) {
                    let body = this.prepForm(this.manufacturer, this.rules_manufacturers);

                    this.saveManufacturer({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.manufacturer) {
                            this.$router.push({ name: "manufacturer", params: { id: data.manufacturer.company_id } });
                        } else {
                        }
                    });
                }
            });
        },
        changeStatus(item) {
            this.status_loader = true;
            let body = { company_id: `${this.$route.params.id}`, status_id: item.option_id };

            this.saveManufacturers({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.manufacturer) {
                    this.manufacturer = this.assignObj2(data.manufacturer, this.rules_manufacturers);
                }
            });
        },
        deleteManufacturers() {
            this.deleteManufacturer({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                console.log(data);
                if (data && data.code == "200") {
                    this.validationOff();
                    this.$router.push({ name: "manufacturers" });
                }
                this.toggleModalLoader(false);
            });
        },
        async refresh(force = false) {
            this.startLoader();

            if (force == true) {
                await this.fetchManufacturer({
                    id: `${this.$route.params.id}`,
                }).then((data) => {
                    if (typeof data !== "undefined" && data.manufacturer) {
                        this.manufacturer = this.assignObj2(data.manufacturer, this.rules_manufacturers);
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(true);
                    }
                });
            } else {
                this.finishLoader();
            }

            if (this.payment_terms.length == 0 || force == true) await this.fetchPaymentTerms({ body: { options: 1 } });
        },
    },
    mounted() {
        this.refresh();
    },
    created() {},
};
</script>
